export const enum LOCAL_ONLY_FEATURES {}

// DON'T IMPORT THIS OBJECT OUTSIDE. IT'S EXPORTABLE ONLY FOR TESTS.
// IN APP CODE IT SHOULDN'T BE IMPORTED
// If you want add local only features, just add them here within the object
// Please don't forget to remove local features before pushing it to remote repo
export const LOCAL_ONLY_FEATURES_VALUES: LocalAppFeatures = {};

type LocalFeatureKeys = keyof typeof LOCAL_ONLY_FEATURES;

export type LocalAppFeatures = Record<(typeof LOCAL_ONLY_FEATURES)[LocalFeatureKeys], boolean>;

export function getLocalOnlyFeatures() {
  // Don't remove this check! Local features should be local only!
  if (process.env.NODE_ENV === 'production') {
    return {};
  }

  return Object.fromEntries(
    Object.entries(LOCAL_ONLY_FEATURES_VALUES).map(([key, value]) => {
      return [key, { defaultValue: value }];
    })
  );
}
